import { render, staticRenderFns } from "./CustomerTagTranslationNewPopup.vue?vue&type=template&id=48bd325c&"
import script from "./CustomerTagTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerTagTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports